import React from "react";
import InteractionPropsDisplay from "../InteractionPropsDisplay";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import InteractionSettings from "../../../../../models/config/InteractionSettings";

const CacheFile = (props: InteractionSettings) => {
  let cacheFile = "NONE";
  if (props.cacheFile) {
    cacheFile = props.cacheFile;
  }
  return (
    <InteractionPropsDisplay
      variant="outlined"
      label="Mapped Survey: "
      avatar={<DriveFileMoveIcon />}
      text={cacheFile}
    />
  );
};

export default CacheFile;
